export const CREDIT_NOTES_PAGE_SEARCH_QUERY_KEY = "search";
export const CREDIT_NOTES_PAGE_PERIOD_QUERY_KEY = "period";
